import { api } from './client';

export interface TaxOffice {
  id: string;
  code: string;
  name: string;
  region_name: string | null;
  is_active: boolean;
}

export interface TaxOfficeUpsertItem {
  code: string;
  name: string;
  region_name?: string | null;
  is_active?: boolean;
}

export const taxOffices = {
  async list(params: { q?: string; limit?: number; offset?: number } = {}) {
    const { data } = await api.get<{ items: TaxOffice[]; total: number }>(
      '/refs/tax-offices',
      { params },
    );
    return data;
  },
  async byCode(code: string) {
    const { data } = await api.get<TaxOffice | null>(
      `/refs/tax-offices/by-code/${encodeURIComponent(code)}`,
    );
    return data;
  },
  async bulkUpsert(items: TaxOfficeUpsertItem[]) {
    const { data } = await api.post<{ created: number; updated: number; total: number }>(
      '/refs/tax-offices/bulk',
      { items },
    );
    return data;
  },
};
